/* This is the EMIS primary learning result grade */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + lastacc"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="800" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 170px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              លំដាប់និទ្ទេស
            </td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ២</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៣</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៤</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៥</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៦</td>
            <td class="row-header" colspan="2">សរុប</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Except last row non teaching staff need minus 1 -->
          <tr v-for="(value, row) in gResult.length" :key="row">
            <!-- This is data coloumn -->
            <td class="td-title">{{ gResult[row] }}</td>
            <!-- Except non teaching column need minus 2 -->
            <td v-for="(value, col) in data[row].d.length" :key="col">
              <numberinput v-model="data[row].d[col]" class="number" />
            </td>
            <!-- This is total column -->
            <td class="row-data">
              <strong>{{ row1[row] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ row2[row] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { gResult } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "lastacc", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      gResult: gResult,
    };
  },
  computed: {
    // Compute function for re-entry program
    row1: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length;
      result = d.reduce(function (r, a, ind) {
        a.d.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last
            if (i % 2 === 0) {
              r[ind] = (r[ind] || 0) + Number(b);
            }
          }
        });
        return r;
      }, []);
      return result;
    },
    row2: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length;
      result = d.reduce(function (r, a, ind) {
        a.d.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last
            if (i % 2 === 1) {
              r[ind] = (r[ind] || 0) + Number(b);
            }
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 45px;
  text-align: center;
}
.td-title {
  width: 170px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-data {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 90px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>
